import React from 'react';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingTimelineFrameRate } from '@/redux/selectors/packagingSelectors';
import { getSMPTETimecode } from '@/components/Packaging/utils';

interface Props {
  framesCount: number;
  color: string;
  isLocked: boolean;
}

const SegmentDuration: React.FC<Props> = ({ framesCount, color, isLocked }) => {
  const frameRate = useAppSelector(selectPackagingTimelineFrameRate);
  const Wrapper = isLocked ? DurationStampLocked : DurationStamp;

  return (
    <Wrapper color={color}>
      <Text>{getSMPTETimecode(framesCount, frameRate)}</Text>
    </Wrapper>
  );
};

export default SegmentDuration;

const DurationStamp = styled.div<{ color: string }>`
  position: absolute;
  bottom: 0;
  left: ${({ theme }) => theme.spacing(1.5)};
  right: ${({ theme }) => theme.spacing(1.5)};

  border-top-left-radius: ${({ theme }) => theme.shape.borderRadius / 2}px;
  border-top-right-radius: ${({ theme }) => theme.shape.borderRadius / 2}px;
  text-align: center;
  background-color: ${({ color }) => color};
  color: #1b1d27;
`;

const DurationStampLocked = styled.div<{ color: string }>`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(0.5)};
  right: ${({ theme }) => theme.spacing(1.25)};

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(0.25, 1)};
  background-color: #5c6df233;
  font-size: 0.66rem;
  color: #ffffffb2;
`;

const Text = styled.div`
  font-size: 0.9rem;
`;
